module.exports = __webpack_public_path__ + "img/usr-background.99327ea2.jpg";